var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExploreActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7767 1.72796C15.8271 4.58559 7.32405 10.5986 3.10678 14.0586C2.47041 14.5807 2.0081 15.3098 2.12084 16.1252C2.19624 16.6706 2.38971 17.3596 2.83043 18.1229C3.27116 18.8863 3.77113 19.3983 4.20572 19.7363C4.8555 20.2416 5.71804 20.2058 6.48839 19.9157C11.5935 17.9935 21.0525 13.6361 26.002 10.7785C26.002 10.7785 22.8043 11.4329 20.7077 7.80149C18.6111 4.17009 20.7767 1.72796 20.7767 1.72796Z",
    fill: "#27374d",
    stroke: "#27374d",
    strokeWidth: 3.09643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7074 7.80261C18.6108 4.17121 20.7764 1.72908 20.7764 1.72908C20.7764 1.72908 23.9741 1.07468 26.0707 4.70608C28.1673 8.33748 26.0017 10.7796 26.0017 10.7796C26.0017 10.7796 22.804 11.434 20.7074 7.80261Z",
    fill: "white",
    stroke: "#27374d",
    strokeWidth: 3.09643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4825 16.0898L10.3218 27.3504",
    stroke: "#27374d",
    strokeWidth: 3.09643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4824 16.0898L20.6431 27.3504",
    stroke: "#27374d",
    strokeWidth: 3.09643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreActive);
export default __webpack_public_path__ + "static/media/exploreActive.8f62e4f29c6e0ed62b01c981838caa9d.svg";
export { ForwardRef as ReactComponent };